import React from "react";

interface GraphCarouselProps {
    graphs: string[];
    currentIndex: number;
    onNext: () => void;
    onPrev: () => void;
}

const GraphCarousel: React.FC<GraphCarouselProps> = ({
    graphs,
    currentIndex,
    onNext,
    onPrev,
}) => {
    if (graphs.length === 0) {
        return null;
    }

    return (
        <div className="relative w-[47.75rem] h-[29.75rem] bg-white rounded-[16px] shadow-md flex-shrink-0 flex items-center justify-center">
            {graphs.length > 1 && (
                <button
                    onClick={onPrev}
                    className="absolute left-4 top-1/2 -translate-y-1/2 bg-gray-200 w-8 h-8 rounded-full flex items-center justify-center shadow-md">
                    ‹
                </button>
            )}

            <img
                src={graphs[currentIndex]}
                alt={`Graph ${currentIndex + 1}`}
                className="max-w-full max-h-full object-contain"
            />

            {graphs.length > 1 && (
                <button
                    onClick={onNext}
                    className="absolute right-4 top-1/2 -translate-y-1/2 bg-gray-200 w-8 h-8 rounded-full flex items-center justify-center shadow-md">
                    ›
                </button>
            )}
        </div>
    );
};

export default GraphCarousel;
